module.exports = __webpack_public_path__ + "img/Stemness-CRC_GSE225857.9b241b54.png";